<template>
  <div class="not-found">
    <i class="ion ion-file-tray-outline not-found__icon"></i>
    <p class="not-found__text" v-if="!this.isDrayage">No data were found.</p>
    <p class="not-found__text" v-else>
      This specific request isn’t available online right now, but no worries! Our team is here to help!
      Reach out to drayage@goglt.com for your quote.</p>
  </div>
</template>

<script>
export default {
  name: "NotFoundData",
  props: {
    isDrayage: {
      type: Boolean,
      default: false
    },
  }
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/_variables' as *;
@use '@/assets/scss/_themes' as *;
.not-found {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 100%;
  &__icon {
    font-size: 2rem;
    color: $color-primary-company;
  }
  &__text {
    font-size: 0.9rem;
    line-height: 1.8;
    word-break: keep-all;
    overflow-wrap: normal;
    white-space: normal;
    font-weight: 600;
    color: $color-primary-company;
  }
}
</style>
